'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _getFeisAge = require('../../../utilities/getFeisAge');

var _getFeisAge2 = _interopRequireDefault(_getFeisAge);

var _paths = require('./paths');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis, person) {
  return function (dispatch, getState) {
    var feis_id = feis.get('id');
    var person_id = person.get('id');

    var events = getState().getIn(['events', 'persons', person_id, 'feiseanna', feis_id, 'eligible']);

    // prefer the cached version
    if (events) return Promise.resolve();

    var champs = person.get('champion') ? 1 : 0;
    var age = (0, _getFeisAge2.default)(feis.toJS(), person.toJS());
    var gender = person.get('gender');

    return dispatch(_defineProperty({
      feis_id: feis_id,
      person_id: person_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisEventsPrefix)(feis_id),
        params: {
          gender: gender,
          age: age,
          champs: champs
        }
      },
      types: ['GET_ELIG_EVENTS_FOR_PERSON_START', 'GET_ELIG_EVENTS_FOR_PERSON', 'GET_ELIG_EVENTS_FOR_PERSON_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/getEligibleEventsForPerson.js
// module id = 634
// module chunks = 0